import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  TextField,
  Typography,
  CardMedia,
  RadioGroup,
  IconButton,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  DialogActions,
  FormLabel,
  List,
} from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    background-color: #2d2b2c;
    color: #DCC6B7;
    width: 90%;
    max-width: 900px;
    box-sizing: border-box;
    border-radius: 16px;
    z-index: 9999;
    overflow: hidden;
    max-height: 100vh;
  }
`;

export const StyledDialogTitle = styled(DialogTitle)`
  color:  #DCC6B7;
  text-align: center;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
`;

export const StyledDialogContent = styled(DialogContent)`
  width: 100%;
  color: #ffffff;
  font-size: 1rem;
  padding: 0;
  max-width: 100%;
  overflow-y:auto;

   &::-webkit-scrollbar {
    width: 6px;
  }
`;

export const StyledDialogInputs = styled("div")`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

 export const StyledFormLabel = styled(FormLabel)`
    color: #ffffff;
    font-weight: 500;
    margin-bottom: 4px;
  `;

export const StyledTypography = styled(Typography)`
  font-size: 1rem;
  color: #ffffff;
  text-align: center;
  margin-bottom: 24px;
  & strong {
    font-weight: bold;
    color: #ffffff;
  }
`;

export const Logo = styled(CardMedia)`
  width: 84px;
  height: 84px;
  margin: 16px auto;
`;

export const StyledButton = styled(Button)`
  background-color: #d7bcae;
  color: #2d2b2c;
  font-weight: bold;
  font-size: 0.875rem;
  padding: 12px;
  box-sizing: border-box;
  border-radius: 8px;
  width: 100%;

  &:hover {
    background-color: #bfa798;
  }
  
  &.Mui-disabled {
    opacity: 0.5;
    color: #2d2b2c;
    background-color: #d7bcae;
  }
`;

export const StyledSecondaryButton = styled(Button)`
  color: #d7bcae;
  border: 1px solid #d7bcae;
  padding: 12px;
  font-size: 0.875rem;
  font-weight: bold;
  box-sizing: border-box;
  border-radius: 8px;
  width: 100%;

  &:hover {
    background-color: rgba(215, 188, 174, 0.2);
  }
`;

export const StyledRadioGroup = styled(RadioGroup)`
  flex-direction: row;
`;

export const StyledDialogCloseButton = styled(IconButton)`
  position: absolute;
  right: 8px;
  top: 8px;
  color: #DCC6B7;
`;

export const StyledAccordion = styled(Accordion)`
  background: transparent;
  box-shadow: none;
  margin: 0 !important;
  padding: 0;

  &::before {
    display: none;
  }
`;

export const StyledAccordionDetails = styled(AccordionDetails)`
  margin-top: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;


export const StyledTextField = styled(TextField)(({ theme }) => ({
  '& input::placeholder': {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: '#d7bcae',
    [theme.breakpoints.down('sm')]: {
      fontSize: 'clamp(0.9rem, 4vw, 1.25rem)',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '1rem',
    },
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#dcc6b7',
    },
    '&:hover fieldset': {
      borderColor: '#dcc6b7',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#dcc6b7',
    },
  },
  '& .MuiInputLabel-root': {
    color: '#dcc6b7',
  },
}));

export const StyledAccordionSummary = styled(AccordionSummary)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-height: 40px;

  .MuiAccordionSummary-content {
    margin: 0;
    flex-grow: 0;
    padding: 0;
    min-height: 0;
  }
    
  .MuiAccordionSummary-expandIconWrapper {
    color: #d7bcae;
    margin-left: 8px; 
    margin-right: auto; 
  }
`;

export const TitleWithAccordionWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const StyledDialogActions = styled(DialogActions)(({ theme, isMobile }) => ({
  flexDirection: isMobile ? 'column-reverse' : 'row',
  alignItems: 'center',
  justifyContent: isMobile ? 'center' : 'flex-end',
  gap: theme.spacing(2),
  marginTop: theme.spacing(3),
  padding: 0,
  width: '100%',

  '& > :not(:first-of-type)': {
    marginLeft: 0,
  },
}));

//  MODAL ALTERNATIVO - PERFIL 4 Afiliados / VENDEDOR MULTIMARCA

export const BannerAlternative = styled('div')`
  background-color: #2d2b2c;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 40px 24px;
  box-sizing: border-box;
`;

export const TitleAlternative = styled('h2')`
  color: #ffffff;
  font-size: 32px;
  font-weight: 700;
  margin: 0;
  text-align: center;
`;

export const SubtitleAlternative = styled('p')`
  color: #ffffff;
  font-size: 20px;
  font-style: italic;
  margin: 8px 0 32px;
  opacity: 0.9;
  text-align: center;
  width: 100%;
  
  @media (max-width: 600px) {
    font-size: 18px;
    margin: 4px 0 24px;
    line-height: 1.2;
    padding: 0 10px;
  }
`;

export const DescriptionAlternative = styled('p')`
  color: #ffffff;
  font-size: 16px;
  line-height: 1.5;
  text-align: center;
  max-width: 650px;
  opacity: 0.8;
`;

export const BenefitList = styled(List)`
  color: #ffffff;
  font-size: 16px;
  margin-bottom: 15px;
  margin-top: 15px;
  padding: 0;
  opacity: 0.8;

  .MuiListItem-root {
    padding: 2px 0;
    display: flex;
    align-items: flex-start;
    
    &::before {
      content: '•';
      margin-right: 8px;
      color: #ffffff;
      
    }
  }
`;

export const FooterDescription = styled('p')`
  color: #ffffff;
  font-size: 16px;
  text-align: center;
  max-width: 650px;
  margin-bottom: 32px;
  white-space: pre-line;
  opacity: 0.8;
`;

export const InputsContainerAlternative = styled('div')`
  width: 100%;
  max-width: 650px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 24px;

  @media (max-width: 600px) {
    display: flex; /* Muda para flex no mobile */
    flex-direction: column; /* Empilha as redes sociais */
    gap: 0; /* O Accordion já tem seus próprios respiros */
  }
`;

export const InputWrapperAlternative = styled('div')`
  flex: 1;
  min-width: 200px;
  display: flex;
  flex-direction: column;
  gap: 4px;

  label {
    color: #ffffff;
    font-weight: 700;
    font-size: 14px;
  }
`;

export const FullWidthInputWrapper = styled(InputWrapperAlternative)`
  grid-column: span 1;
`;

export const SendButton = styled(Button)`
  background-color: #DCC6B7;
  color: #2d2b2c;
  font-weight: 700;
  
  padding: 12px 80px;
  font-size: 18px;
  
  border-radius: 8px;
  text-transform: none;
  margin-top: 16px;
  
  &:hover {
    background-color: #bfa798;
  }

  &.Mui-disabled {
    opacity: 0.5;
    background-color: #DCC6B7;
    color: #2d2b2c;
  }

  @media (max-width: 600px) {
    width: 100%;
    padding: 12px;
  }
`;